import {
  ChartNoAxesColumnIncreasing,
  PhoneOutgoing,
  SettingsIcon,
  Waypoints,
} from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center mt-[150px] ">
      <div>
        <div className="text-[80px] font-bold text-gray-200 text-center">
          404
        </div>

        <div className="text-[17px] mt-2 font-bold text-black text-center">
          Page not found
        </div>

        <div className="text-[15px] mt-2  text-black text-center">
          Sorry we couldn't find the page you're looking for
        </div>

        <div className="bg-white w-[400px] h-fit  px-3 py-4 shadow-md rounded-lg mt-5">
          <div className="text-[15px] font-bold text-black text-left">
            Quick navigation
          </div>

          <div className="px-4 grid grid-cols-2 gap-4 mt-3 ">
            <div
              className="text-[14px] flex items-center text-black font-bold  cursor-pointer"
              onClick={() => navigate("/dashboard")}
            >
              <ChartNoAxesColumnIncreasing className="w-[15px] text-gray-400 mr-3 " />
              <div>Dashboard</div>
            </div>

            <div
              className="text-[14px] flex items-center text-black font-bold  cursor-pointer"
              onClick={() => navigate("/dashboard/dialer")}
            >
              <PhoneOutgoing className="w-[15px] text-gray-400 mr-3 " />
              <div>Dialer</div>
            </div>

            <div
              className="text-[14px] flex items-center text-black font-bold  cursor-pointer"
              onClick={() => navigate("/dashboard/call-routings")}
            >
              <Waypoints className="w-[15px] text-gray-400 mr-3 " />
              <div>Call Routes</div>
            </div>

            <div
              className="text-[14px] flex items-center text-black font-bold  cursor-pointer"
              onClick={() => navigate("/dashboard/settings")}
            >
              <SettingsIcon className="w-[15px] text-gray-400 mr-3 " />
              <div>Settings</div>
            </div>
          </div>

          <div className="flex items-center justify-center mt-4">
            <div
              onClick={() => {
                window.location.href =
                  "mailto:hello@twilanswer.com?subject=Support Request&body=Hello Twilanswer Team,";
              }}
              className="border-[1px] border-gray-[200] w-[200px]  text-center rounded-md text-[14px] px-3 py-2 font-medium hover:bg-gray-100 cursor-pointer"
            >
              Contact Support
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
